import { get } from 'lodash'
import { common, orange } from '@mui/material/colors'

export const ROW_HEIGHT = 104
export const HEADER_HEIGHT = 42
export const INPUT_WIDTH = '4rem'

export const defaultValues = {
  moveFromRouteId: 'UNASSIGNED',
  moveToRouteId: '',
}

// Selection no longer recolors the marker — the dispatcher gets a blue outer
// halo (via highlightedStopIds → BulkDeckMarkerLayer / StopMarker) and the
// pill itself stays in its unassigned (orange) treatment regardless of whether
// it's currently checked. The rowsById/selectedFromRows args are kept to
// preserve the call-site signature even though the resulting marker shape no
// longer depends on selection.
export const updateUnassignedMarkers = (_selectedFromRows, _rowsById, fromMarkers) => {
  return fromMarkers.map(feature => {
    const properties = get(feature, 'properties', {})
    return {
      ...feature,
      properties: {
        ...properties,
        color: common.white,
        'border-color': orange[300],
        icon: 'to-be-assigned-marker',
        'route-text-color': common.black,
      },
    }
  })
}
